import React, { Component } from 'react'
import SummarySalesChart from '@components/SummarySalesChart'
import { SimpleCard } from '@components/AdminCard'
import {
  FaSackDollar,
  FaUser,
  FaLandmark,
  FaWallet,
  FaBookOpen,
  FaGraduationCap,
  FaUsers,
  FaGlobe,
  FaCross,
  FaLaptop,
  FaGear,
} from 'react-icons/fa6'

// Categorias (linhas de negócio) exibidas no card "Repasse por categoria", na ordem do layout.
const REPASSE_CATEGORIES = [
  { label: 'Literatura', key: 'retributive_amount_lij', Icon: FaBookOpen, color: '#8B5FBF' },
  { label: 'Didático', key: 'retributive_amount_didact', Icon: FaGraduationCap, color: '#3B82C4' },
  { label: 'Educamos', key: 'retributive_amount_edu', Icon: FaUsers, color: '#2E9E5B' },
  { label: 'Bilíngue', key: 'retributive_amount_bil', Icon: FaGlobe, color: '#E58E26' },
  { label: 'Ensino religioso', key: 'retributive_amount_ere', Icon: FaCross, color: '#D9534F' },
  { label: 'Digital', key: 'retributive_amount_dig', Icon: FaLaptop, color: '#15cbbc' },
  { label: 'Serviços', key: 'retributive_amount_ser', Icon: FaGear, color: '#6B7280' },
]

const RepasseByCategory = ({ summary, total }) => (
  <div className="summary__repasse">
    <div className="summary__repasse-header">
      <FaSackDollar className="summary__repasse-header-icon" aria-hidden="true" />
      <span className="summary__repasse-title">Repasse por categoria</span>
    </div>
    <ul className="repasselist">
      <li className="repasselist__head">
        <span className="repasselist__label">Categoria</span>
        <span className="repasselist__value">Valor</span>
      </li>
      {REPASSE_CATEGORIES.map(({ label, key, Icon, color }) => (
        <li key={key} className="repasselist__item">
          <span className="repasselist__label">
            <Icon className="repasselist__icon" style={{ color }} aria-hidden="true" />
            {label}
          </span>
          <span className="repasselist__value">{summary[key]}</span>
        </li>
      ))}
      <li className="repasselist__item repasselist__item--total">
        <span className="repasselist__label">Total</span>
        <span className="repasselist__value">{total}</span>
      </li>
    </ul>
  </div>
)

export class Default extends Component {
  render() {
    // let { retributive_amount, total_orders, total_students, total_products } = this.props.summary
    let {
      children,
      summary: {
        retributive_amount,
        total_products,
        total_amount,
        total_students,
        total_students_paid,
        amount_teachers,
        ...rest
      },
    } = this.props

    const data = [
      {
        name: 'Comprado',
        value: total_students_paid,
        fill: '#F5A8A8',
      },
      {
        name: 'Em aberto',
        value: total_students,
        fill: '#6AABD6',
      },
    ]

    return (
      <div className="summary">
        <div className="summary__header">
          <h3 className="summary__title">Pedido</h3>
        </div>
        <div>{children}</div>
        <SummarySalesChart data={data} />
        <div className="summary__cards">
          <SimpleCard
            className="summary__card"
            title="Valor total"
            value={total_amount}
            color="#8DC496"
            position="top"
          />
          <SimpleCard
            className="summary__card"
            title="Valor total venda professor(a)"
            value={amount_teachers}
            color="#6AABD6"
            position="top"
          />
          <SimpleCard className="summary__totalcard">
            <div className="summary__totalbooks">
              <div className="totalbooks__total">
                <span className="simplecard__title">Valor de repasse total</span>
                <span className="totalbooks__value">{retributive_amount}</span>
              </div>
              <div className="column">
                <span className="simplecard__title">Valor total do repasse literatura</span>
                <span className="totalbooks__value">{rest.retributive_amount_lij}</span>
              </div>
              <div className="column">
                <span className="simplecard__title">Valor total do repasse didático</span>
                <span className="totalbooks__value">{rest.retributive_amount_didact}</span>
              </div>
              <div className="column">
                <span className="simplecard__title">Valor total do repasse digital</span>
                <span className="totalbooks__value">{rest.retributive_amount_dig}</span>
              </div>
              <div className="column">
                <span className="simplecard__title">Valor total do repasse educamos</span>
                <span className="totalbooks__value">{rest.retributive_amount_edu}</span>
              </div>
              <div className="column">
                <span className="simplecard__title">Valor total do repasse serviços</span>
                <span className="totalbooks__value">{rest.retributive_amount_ser}</span>
              </div>
              <div className="column">
                <span className="simplecard__title">Valor total do repasse serviços</span>
                <span className="totalbooks__value">{rest.retributive_amount_ere}</span>
              </div>
            </div>
          </SimpleCard>
          <SimpleCard
            className="summary__card"
            title="Comprados"
            value={`${total_products} produtos`}
            color="#ECCC62"
            position="bottom"
          />
        </div>
      </div>
    )
  }
}

export class SM extends Component {
  render() {
    let {
      children,
      summary,
      summary: { retributive_amount, total_amount, net_amount, total_students, total_students_paid, amount_teachers },
    } = this.props

    const data = [
      {
        name: 'Comprado',
        value: total_students_paid,
        fill: '#F5A8A8',
      },
      {
        name: 'Em aberto',
        value: total_students,
        fill: '#6AABD6',
      },
    ]

    return (
      <div className="summary">
        <div className="summary__header">
          <h3 className="summary__title">Dashboard</h3>
        </div>
        {children}
        <div className="summary__indicators">
          <SimpleCard
            className="summary__indicator-card"
            title="Valor total"
            value={total_amount}
            color="#2E8B57"
            iconColor="#4CAF7D"
            icon={<FaSackDollar />}
          />
          <SimpleCard
            className="summary__indicator-card"
            title="Valor total venda professor(a)"
            value={amount_teachers}
            color="#2F6FB0"
            iconColor="#5B9BD5"
            icon={<FaUser />}
          />
          <SimpleCard
            className="summary__indicator-card"
            title="Valor de repasse total"
            value={retributive_amount}
            color="#B5820A"
            iconColor="#E0A93B"
            icon={<FaLandmark />}
          />
          <SimpleCard
            className="summary__indicator-card"
            title="Valor total líquido"
            value={net_amount}
            color="#7A5CC4"
            iconColor="#9B7ED9"
            icon={<FaWallet />}
          />
        </div>
        <div className="summary__panels">
          <div className="summary__chart-panel">
            <SummarySalesChart data={data} />
          </div>
          <div className="summary__repasse-panel">
            <RepasseByCategory summary={summary} total={retributive_amount} />
          </div>
        </div>
      </div>
    )
  }
}

